module.exports = __webpack_public_path__ + "./fonts/6bb0a11e218ee3215cbae0f26f95727f.woff";